import { BaseResourceService } from '/@/modules/core/app/services/abstracts/BaseResourceService';
import Logger from '/@/modules/core/app/helpers/Logger';

export class BaseListService extends BaseResourceService {
  /**
   * @var {object<string, any>}
   */
  filterParams = {};

  /**
   * @abstract
   * @returns BaseModel
   */
  getModel() {
    Logger.log('getModel() must be implemented', Logger.LEVEL_ERROR);
  }

  /**
   * @abstract
   * @returns string
   */
  getRoute() {
    Logger.log('getRoute() must be implemented', Logger.LEVEL_ERROR);
  }

  /**
   * @returns {object}
   */
  addParams(params = {}) {
    return { ...params, ...this.filterParams };
  }

  /**
   * @param {string} key
   * @param {*} value
   */
  setFilterParam(key, value) {
    this.filterParams[key] = value;
  }

  /**
   * @param {string} key
   */
  unsetFilterParam(key) {
    delete this.filterParams[key];
  }

  /**
   * @returns {void}
   */
  resetFilterParams() {
    this.filterParams = {};
  }

  /**
   * @param {string} key
   * @returns {*}
   */
  getFilterParam(key) {
    return this.filterParams[key];
  }

  /**
   * @returns {object<string, any>}
   */
  getFilterParams() {
    return this.filterParams;
  }

  /**
   * @param params
   * @returns {Promise<*>}
   */
  async getRows(params = {}) {
    params = this.addParams(params ?? {});
    return this.resource.getItems(params);
  }

  /**
   * @param id
   * @param params
   * @returns {Promise<any>}
   */
  async getRow(id, params = {}) {
    params = this.addParams(params);
    return this.resource.getItem(id, params);
  }

  /**
   * @param params
   * @param model
   * @returns {Promise<any[]>}
   */
  async getTotal(params = {}, model = null) {
    params = this.addParams(params ?? {});
    return this.resource.getTotal(params, model);
  }

  /**
   * @param id
   * @returns {Promise<any[]>}
   */
  async copyRow(id) {
    return this.resource.copyItem(id);
  }

  /**
   * @param id
   * @returns {Promise<any[]>}
   */
  async deleteRow(id) {
    return this.resource.deleteItem(id);
  }
}
